import './App.css';
import React from 'react';
import VideoChatLocal from "./VideoChatLocal"
import Remote from "./remote"
import MIDISequencer from "./MIDISequencer"
import VideoChatRemote from "./VideoChatRemote"
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom'
import { WebRTCProvider } from './contexts/WebRTCContext'
import MIDIControlPanel from './MIDIControlPanel'
import { MIDIProvider } from './contexts/MIDIContext'

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Moog Sirin Local Controls</h1>
      </header>
      <main className="App-main">
        <WebRTCProvider>
          <MIDIProvider>
            <VideoChatLocal />
            <MIDIControlPanel />
          </MIDIProvider>
        </WebRTCProvider>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div>
        {/* Navigation */}
        <nav style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
          <Link to="/" style={{ marginRight: '10px' }}>Home</Link>
          <Link to="/remote" style={{ marginRight: '10px' }}>Remote Page</Link>
          <Link to="/sequencer" style={{ marginRight: '10px' }}>MIDI Sequencer</Link>
          <Link to="/video-chat-page">Video Chat Remote Page</Link>
        </nav>

        {/* Route Definitions */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/remote" element={<Remote />} />
          <Route path="/sequencer" element={<MIDISequencer />} />
          <Route path="/video-chat-page" element={<VideoChatRemote />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;